import { formaterMontantDevise } from '../../utils/devise';

/** Formate un montant dans la devise de la boutique active avec séparateurs français (chiffres tabulaires côté CSS). */
export const formaterMontant = (valeur) => formaterMontantDevise(valeur);
